import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { IRealtorPayment } from '../models';

interface IProps {
  page?: number;
  size?: number;
  realtorId: number;
  date?: string | null;
}

export function useCompanyRealtorBalanceTable(props: IProps) {
  const { date, realtorId, page = 1, size = 10 } = props;

  return useQuery<Pagination<IRealtorPayment>>({
    queryKey: ['company-realtor-balance-table', props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({ url: '/v1/company/realtor/company-payment', query: { page, size, realtorId, date } })
      );

      return res.data.data;
    },
    enabled: !!realtorId
  });
}
